module.exports = __webpack_public_path__ + "static/media/lotus.947aa47b.svg";